import { Role } from 'src/constants/enums';

export const UNIVERSAL_ROLE_SET: Set<Role> = new Set([
    Role.Admin,
    Role.Writer,
    Role.Editor,
    Role.Viewer,
    Role.Maple,
    Role.CAM
]);

export const VIEWER_ROLE_SET: Set<Role> = new Set([Role.Admin, Role.Writer, Role.Editor, Role.CAM, Role.Viewer]);

export const MAPLE_ROLE_SET: Set<Role> = new Set([Role.Admin, Role.Writer, Role.Editor, Role.Maple]);

export const EDITOR_ROLE_SET: Set<Role> = new Set([Role.Admin, Role.Writer, Role.Editor]);

export const WRITER_ROLE_SET: Set<Role> = new Set([Role.Admin, Role.Writer]);

export const CAM_ROLE_SET: Set<Role> = new Set([Role.Admin, Role.Writer, Role.Editor, Role.CAM]);

export const ADMIN_ROLE_SET: Set<Role> = new Set([Role.Admin]);
